import { render, staticRenderFns } from "./OutputData.vue?vue&type=template&id=2229099a&"
import script from "./OutputData.vue?vue&type=script&lang=js&"
export * from "./OutputData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports